var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#E7E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 21.5H22.3337V23.1667H24.0003M24.0003 18.1667H22.3337V19.8333H24.0003M25.667 24.8333H19.0003V23.1667H20.667V21.5H19.0003V19.8333H20.667V18.1667H19.0003V16.5H25.667M17.3337 14.8333H15.667V13.1667H17.3337M17.3337 18.1667H15.667V16.5H17.3337M17.3337 21.5H15.667V19.8333H17.3337M17.3337 24.8333H15.667V23.1667H17.3337M14.0003 14.8333H12.3337V13.1667H14.0003M14.0003 18.1667H12.3337V16.5H14.0003M14.0003 21.5H12.3337V19.8333H14.0003M14.0003 24.8333H12.3337V23.1667H14.0003M19.0003 14.8333V11.5H10.667V26.5H27.3337V14.8333H19.0003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollFrame);
export default __webpack_public_path__ + "static/media/PayrollFrame.89b15042ee53314d6e9d74dc76e8faa7.svg";
export { ForwardRef as ReactComponent };